import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./App.css";
import Loading from "../src/components/generico/Loading";
import AuthService from "./services/login/auth.service";

import MegaMenu from "./components/Layout/TemplatePage/MegaMenu";

import Footer from "./components/Layout/TemplatePage/Footer";
import Popup from "react-popup";
import "react-toastify/dist/ReactToastify.css";
import IdleTimer from "react-idle-timer";
import authService from "./services/login/auth.service";
import { componentes } from "./components/generico/utils/Componentes";
import ConfigService from "./services/configuracion/ConfigService";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cambiar: undefined,
      currentUser: undefined,
    };

    AuthService.init();

    this.idleTimer = null;
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnActive = this.handleOnActive.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);

    //this.manageTimeOut=undefined;

    // inicializar Instana
    const instanaKey = process.env.REACT_APP_INSTANA_KEY;
    window.ineum('reportingUrl', 'https://eum-coral-saas.instana.io');
    window.ineum('key', instanaKey);
    window.ineum('trackSessions');
    
  }

  componentDidMount() {

    const user = AuthService.getCurrentUser();
    const isNew = AuthService.getIsNewUser();

    if (user) {
      this.setState({
        currentUser: user,
        cambiar: isNew,
      });

      var socio = authService.getSocio();
      // console.log({ socio })
      window.ineum('user', `socio: ${socio?.numeroSocio}`, socio?.nombreCompleto, `ci: ${socio?.numeroCedula}`)

    }
  }

  isValid(pinTransaccional) {
    const esNuevo = AuthService.getIsNewUser();
    const visualizar = "none"; //// no mostrar opciones del menu

    switch (esNuevo) {
      case "S":
        return <MegaMenu visualizar={visualizar} />;
      case "N":
        if (pinTransaccional === "S")
          return <MegaMenu visualizar={visualizar} />;
        else
          return (
            <div>
              <MegaMenu />
              <Footer />
            </div>
          );
      default:
        return <MegaMenu visualizar="none" />;
    }
  }


  notifiPopupInactividad = (titulo, mensaje, timeOutId) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Quedarte",
            className: "success",
            action: function () {
              clearTimeout(timeOutId);
              Popup.close();
            },
          },
        ],
        left: [
          {
            text: "Cerrar Sesión",
            className: "",
            action: function () {
              authService.logout();
              Popup.close();
            },
          },
        ],
      },

    });


  render() {
    const { currentUser, cambiar } = this.state;

    return (
      <div>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={300000}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />

        <Router>
          <Loading />
          <Popup />
          {/* <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          /> */}
          {currentUser ? (
            this.isValid(sessionStorage.getItem("pinTransaccional"))
          ) : (
            <span />
          )}

          <Switch>

            <Route exact path={["/", "/login"]} >
              {componentes["login"]}
            </Route>

            <Route exact path={["/", "/pinAcceso"]} >
              {componentes["pinAcceso"]}
            </Route>

            <Route exact path={["/", ConfigService.getPathByName("pinTransaccional")?.url]} >
              {componentes["pinTransaccional"]}
            </Route>

            {/************************PAGINA DE ERRORES***********************/}
            {/*<Route component={() => <Error404 logueado="NO" />} />*/}
          </Switch>
        </Router>
      </div>
    );
  }

  handleOnAction(event) {
    if (authService.getCurrentUser() != null && this.idleTimer != null) {
      var elapsedTime = this.idleTimer.getElapsedTime() / 1000;
      var timeToRefresh = authService.getCurrentUser().expires_in;
      //Si el tiempo transcurrido desde el login es mayor al tiempo de vida del token=> llamar al refreshToken
      //Resetear el timer cuando se tenga un token nuevo.
      if (elapsedTime >= timeToRefresh) {

        //llamar al endpoint
        /*authService
          .refreshToken(authService.getCurrentUser().refresh_token)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            console.log("jdata", jsonData);

            // this.idleTimer.reset() ;
          });*/
      }
      //console.log("tiempo de conexión", this.idleTimer.getElapsedTime() / 1000);
    }
  }

  handleOnActive(event) {
    //console.log("user is active", event);
    // console.log("time remaining", this.idleTimer.getRemainingTime());
    //console.log("tiempo de conexión", this.idleTimer.getElapsedTime() / 1000);
  }

  handleOnIdle(event) {
    //console.log("user is idle", event);
    //console.log("last active", this.idleTimer.getLastActiveTime());
    //console.log("time remaining", this.idleTimer.getRemainingTime());
    if (this.idleTimer.getRemainingTime() === 0) {
      //console.log("token", authService.getCurrentToken().length);
      if (authService.getCurrentToken().length !== 0) {
        Popup.queue(
          this.notifiPopupInactividad(
            "Has estado Inactivo",
            "¿Quieres quedarte en el sitio?",
            this.iniciarTimeOut()
          )
        );
      }
    }
  }

  //// inicia 10 segundo antes de cerrar sesion si el usuario no responde al popup 
  iniciarTimeOut() {
    var manageTimeOut = setTimeout(function () {
      authService.logout();
    }, 10000);
    return manageTimeOut;
  }
}

export default App;
